import React, { useEffect, useState } from "react";
import Form from "./Form";
import { tryCatch } from "@/helpers/async_helper";
import api from "@/shared/services/api";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { notificationUtils } from "@/utils/notificationToast";

const EditEnterprise = () => {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState({});
  const navigate = useNavigate();
  const getInformation = async () => {
    const { data: response, error } = await tryCatch(
      api.get(`/enterprise/${id}`)
    );
    if (error || response === null) {
      console.error("Error:", error);
      notificationUtils("danger", "Error al obtener la empresa");
      navigate("/users/list");
    }
    setItem(response!.data.data);
  };

  useEffect(() => {
    getInformation();
  }, []);

  return <Form isEdit itemEdit={item} />;
};

export default EditEnterprise;
